import React, { useEffect, useState } from "react";
import moment from "moment";

import { apiService } from "service/ApiService";
import { notify } from "service/NotificationService";

import TargetsTable from "components/Cards/TargetsTable";

// Buttons
import EditButton from "components/Buttons/EditButton";

export default function TargetForm({ companyId = null }) {
  const [data, setData] = useState([]);
  const [targetAmount, setTargetAmount] = useState(0);
  const [month, setMonth] = useState(moment().format("MM/YYYY"));
  const [errorMessage, setErrorMessage] = useState("");

  const [isDisabled, setIsDisabled] = useState(false);

  const handleError = (error) => notify("error", error);
  const handleUpdate = (update) => notify("update", update);

  useEffect(() => {
    if (!companyId) return;
    apiService
      .get(`api/companies/${companyId}/targets`)
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        handleError(error.message);
      });
  }, []);

  const save = () => {
    setIsDisabled(true);
    const target = {
      target_amount: targetAmount ? targetAmount : undefined,
      month: month ? month : undefined,
    };

    if (companyId) {
      apiService
        .postJson(`api/companies/${companyId}/targets`, target)
        .then((resp) => {
          handleUpdate("The target saved successfully");
          setIsDisabled(false);
          window.location.reload();
        })
        .catch((error) => {
          handleError(error.message);
          setIsDisabled(false);
        });
    } else {
      handleError("Create a company first");
      setIsDisabled(false);
    }
  };

  return (
    <>
      <form>
        <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">Company Targets</h6>
        <div className="flex flex-wrap">
          <div className="w-full px-4">
            <div className="relative w-full mb-3">
              <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Target Amount (€)
              </label>
              <input
                type="number"
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Target Amount"
                required={true}
                value={targetAmount}
                onChange={(e) => {
                  setTargetAmount(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="w-full px-4">
          <div className="relative w-full mb-3">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
              Month
            </label>
            <input
              type="string"
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              placeholder="Month"
              required={true}
              value={month}
              onChange={(e) => {
                setMonth(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="pt-4 px-4">{companyId ? <EditButton handler={save} disabled={isDisabled} /> : null}</div>
        {errorMessage ? (
          <>
            <p style={{ color: "crimson" }}>
              <i className="fa fa-exclamation-circle"></i> {errorMessage}
            </p>
          </>
        ) : null}
      </form>
      <div className="mt-6 px-4 rounded">
        <TargetsTable color="light" data={data} />
      </div>
    </>
  );
}
